import { InjectionToken } from '@angular/core';

export const PcsErrorsToken = new InjectionToken<any>('PCS_ERRORS_TOKEN');
